"use strict";

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (!this.dataset.url) {
        this.configureItems();
        return;
      }
      fetch(this.dataset.url).then(response => response.text()).then(text => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
        this.configureItems();
      }).catch(e => {
        console.error(e);
      });
    };
    this.configureItems = this.configureItems.bind(this);
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 200px 0px"
    }).observe(this);
  }
  configureItems() {
    if (this.dataset.recommendationsInitialized === "true") return;
    const items = Array.from(this.querySelectorAll(".product-item"));
    if (!items.length) return;
    this.dataset.recommendationsInitialized = "true";
    const sliders = [];
    items.forEach((item, idx) => {
      const el = item.querySelector(".product__images-container");
      if (!el) return;
      sliders.push({
        container: el,
        item,
        swiper: null
      });

      const buildItemSlider = sliderState => {
        if (sliderState.swiper || window.innerWidth <= 768) return;
        sliderState.container.classList.add("slider-mode");
        sliderState.swiper = new Swiper(sliderState.container, {
          initialSlide: sliderState.container.getAttribute("data-start-index") ? Number(sliderState.container.getAttribute("data-start-index")) - 1 : 0,
          slidesPerView: 1,
          navigation: {
            prevEl: sliderState.container.querySelector(".slider-btn--prev"),
            nextEl: sliderState.container.querySelector(".slider-btn--next")
          },
          loop: sliderState.container.querySelectorAll(".swiper-slide").length > 1,
          observer: true,
          observeParents: true,
          updateOnImagesReady: true
        });
      };

      const destroyItemSlider = sliderState => {
        if (!sliderState.swiper) return;
        sliderState.swiper.destroy(true, true);
        sliderState.swiper = null;
        sliderState.container.classList.remove("slider-mode");
      };

      sliders[idx].build = () => buildItemSlider(sliders[idx]);
      sliders[idx].destroy = () => destroyItemSlider(sliders[idx]);
      buildItemSlider(sliders[idx]);

      const toggleHover = state => {
        if (state && window.innerWidth > 768) {
          item.classList.add("--hovered");
        } else {
          item.classList.remove("--hovered");
        }
      };
      item.addEventListener("mouseenter", () => toggleHover(true));
      item.addEventListener("mouseleave", () => toggleHover(false));
      item.addEventListener("touchstart", () => toggleHover(true));
      item.addEventListener("touchend", () => toggleHover(false));
    });
    let mainSlider = [];
    const toggleMainSlider = destroy => {
      if (destroy) {
        if (mainSlider[0]) {
          mainSlider[0].destroy(true, true);
          mainSlider[0] = null;
        }
        sliders.forEach(slider => {
          if (slider) slider.build();
        });
        return;
      }
      sliders.forEach(slider => {
        if (slider) slider.destroy();
      });
      const el = this.querySelector(".product-recommendations__wrapper");
      mainSlider[0] = new Swiper(el, {
        speed: 400,
        slidesPerView: "auto",
        loop: false,
        initialSlide: 0,
        spaceBetween: 16,
        centeredSlides: true,
        centeredSlidesBounds: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        updateOnImagesReady: true,
        roundLengths: true
      });
    };
    if (window.innerWidth <= 768) toggleMainSlider();
    window.addEventListener("resize", () => {
      if (window.innerWidth <= 768 && !mainSlider[0]) {
        toggleMainSlider();
      } else if (window.innerWidth > 768 && mainSlider[0]) {
        toggleMainSlider(true);
      }
    });
  }
}
customElements.define("product-recommendations", ProductRecommendations);
